import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../Cadenas/Cadenas";
import { estAutorizacionDirecta } from "../Categorias y Estados/estAutorizacionDirecta";
import { Clientes } from "../Clientes/Clientes";
import { Servicios } from "../Servicios/Servicios";
import { Tiendas } from "../Tiendas/Tiendas";
import { ACTDescargarFotos } from "./ACTDescargarFotos";
import { ACTExportarExcel } from "./ACTExportarExcel";
import { ACTExportarExcelConsolidado } from "./ACTExportarExcelConsolidado";
import { ACTExportarExcelPorServicios } from "./ACTExportarExcelPorServicios";
import { ACTExportarPdf } from "./ACTExportarPdf";
import { BaseClientesViewColumnsOverrides } from "./BaseClientesViewColumnsOverrides";
import { BaseReportesViewColumnsOverrides } from "./BaseReportesViewColumnsOverrides";

const currentDate = new Date();

const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Cliente' }),
        dt_fecha_desde: new EntityColumn<Date>({ name: 'dt_fecha_desde', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Visita Desde', defaultValue: currentDate }),
        dt_fecha_hasta: new EntityColumn<Date>({ name: 'dt_fecha_hasta', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Visita Hasta', defaultValue: currentDate }),
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Cadena' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tienda' }),
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Servicio' }),
        c_autorizacion_directa_status_id: new EntityColumn<string>({ name: 'c_autorizacion_directa_status_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Estado' }),
        dt_fecha_realizado_desde: new EntityColumn<Date>({ name: 'dt_fecha_realizado_desde', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Hora Realizado Desde' }),
        dt_fecha_realizado_hasta: new EntityColumn<Date>({ name: 'dt_fecha_realizado_hasta', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha Hora Realizado Hasta' }),
        vc_servicios: new EntityColumn<string[]>({ name: 'vc_servicios', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Servicio', isArray: true }),
        vc_status: new EntityColumn<string[]>({ name: 'vc_status', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Estado', isArray: true }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        repo_brwBaseClientes: {
            name: 'repo_brwBaseClientes', keyMappings: { c_cliente_id: 0 }
            , gridColumnsOverrides: BaseClientesViewColumnsOverrides
        },
        repo_brwBaseRuteos: {
            name: 'repo_brwBaseRuteos', keyMappings: { c_cliente_id: 0 }
        },
        repo_brwBaseReportes: {
            name: 'repo_brwBaseReportes', keyMappings: { c_cliente_id: 0 }
            , gridColumnsOverrides: () => BaseReportesViewColumnsOverrides(17)
        },
        repo_brwBaseReportesDetallada: {
            name: 'repo_brwBaseReportesDetallada', keyMappings: { c_cliente_id: 0 }
            , gridColumnsOverrides: () => BaseReportesViewColumnsOverrides(17)
        },
        repo_brwBaseQuiebresrepo_brwBaseQuiebres: {
            name: 'repo_brwBaseQuiebres', keyMappings: { c_cliente_id: 0 }
            , gridColumnsOverrides: BaseClientesViewColumnsOverrides
        },
        repo_brwBasePreciosrepo_brwBasePrecios: {
            name: 'repo_brwBasePrecios', keyMappings: { c_cliente_id: 0 }
        },
        repo_brwBaseNovedades: {
            name: 'repo_brwBaseNovedades', keyMappings: { c_cliente_id: 0 }
        },
        repo_brwBaseReportesFotos: {
            name: 'repo_brwBaseReportesFotos', keyMappings: { c_cliente_id: 0 }
            , gridColumnsOverrides: () => BaseReportesViewColumnsOverrides(8)
        },
    }
)

const lookups = () =>
(
    {
        'Clientes': {
            name: 'Clientes',
            viewMapping: { keyIndex: 0, descriptionIndex: 2 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Clientes(client, parentKeys)
        },
        'AutorizacionDirecta': {
            name: 'AutorizacionDirecta',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new estAutorizacionDirecta(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 4 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Servicios(client, parentKeys)
        },
    }
)

const procs = () =>
(
    {
        repo_qryReportes: { name: 'repo_qryReportes' },
        repo_qryReportesDetallada: { name: 'repo_qryReportesDetallada' },
        repo_qryReportesPorServicio: { name: 'repo_qryReportesPorServicio' },
        repo_qryReportesFotos: { name: 'repo_qryReportesFotos' },
    }
)

const clientActions = () =>
(
    {
        ACTExportarExcel: ACTExportarExcel,
        ACTExportarExcelPorServicios: ACTExportarExcelPorServicios,
        ACTExportarPdf: ACTExportarPdf,
        ACTDescargarFotos: ACTDescargarFotos,
        ACTExportarExcelConsolidado: ACTExportarExcelConsolidado,
    }
)

export class ReportesDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    procs = procs();
    clientActions = clientActions();

    constructor() {
        super('Reportes');
    }
}